import store from "@/store";
import { UserNotification } from "@/ui-models";
import { Module, Mutation, VuexModule } from "vuex-module-decorators";

@Module({ dynamic: true, store, name: "snackbar" })
export default class SnackbarModule extends VuexModule {
  private userNotification: UserNotification | null = null;

  get notification(): UserNotification | null {
    return this.userNotification;
  }

  @Mutation
  notifyUser(notification: UserNotification): void {
    this.userNotification = notification;
  }
}
